export default __webpack_public_path__ + "static/MediaContentTen-59dfe463e316ccc3f0abded3d8552e4b.webp";